<div class="breadcrumb_outer">
    <ul class="breadcrumb">
        <li>
            <a>{{ company_name }}:</a>
        </li>
        <li class="active" *ngFor="let item of breadcrumbsArray">
            <a (click)="goToPageLink(item.page_ref)">
                {{ item.page_title }}
            </a>
        </li>
    </ul>
    <div class="right">
        <span>{{ today }}</span>
    </div>
</div>

<div class="tag_powered_by bottomPowerBy">
    <span>Powered by: <b>Enertics</b></span>
</div>

<div class="Content_outer">
    <div class="row">
        <div class="col-md-12">

            <!-- SETTINGS ICON -->
            <div class="tab_right">
                <span class="seen">
                    <img style="width: 20px; height: 20px; cursor: pointer" src="./assets/settings.png"
                        [matMenuTriggerFor]="menu" />
                </span>
            </div>

            <!-- SETTINGS MENU -->
            <mat-menu #menu="matMenu" class="stroked-menu">
                <div class="menu-item-container">
                    <button mat-stroked-button color="accent" class="details-button stroked-menu-button"
                        (click)="changeModalType('list_gateways')">
                        <mat-icon>info</mat-icon>
                        <span>Edit Gateways</span>
                    </button>

                    <button mat-stroked-button color="accent" class="details-button stroked-menu-button"
                        (click)="changeModalType('list_sensors')">
                        <mat-icon>info</mat-icon>
                        <span>Edit Sensors</span>
                    </button>

                    <button mat-stroked-button color="warn" class="details-button stroked-menu-button"
                        (click)="changeModalType('delete_powertrain')">
                        <mat-icon>delete</mat-icon>
                        <span>Delete Powertrain</span>
                    </button>
                </div>
            </mat-menu>

            <!-- ================= ROW 1 ================= -->
            <div class="flex mb-2 pt-cards-wrapper" style="
          margin-top: 35px;
          align-items: stretch;
          width: 99%;
          margin-left: 10px;
          flex-direction: row;
          display:flex;
        ">
                <!-- PIEZO IMAGE (70%) -->
                <app-piezo-image-container class="w-70 flex_80 pt_image_mail_container"></app-piezo-image-container>

                <!-- PIEZO ANOMALY (20%) -->
                <app-piezo-anomaly-card class="flex_20" style="display:block"></app-piezo-anomaly-card>
            </div>

            <!-- ================= ROW 2 ================= -->
            <div class="d-flex pt-cards-wrapper" style="width: 98%; margin-left: 20px">
                <!-- SENSOR TABLE -->
                <div class="sensors-table">
                    <app-piezo-table></app-piezo-table>
                </div>

                <!-- HEALTH + ALERTS -->
                <div class="border_wrapper health_status_alarms_box" style="width: 40%">
                    <app-piezo-healthbar></app-piezo-healthbar>
                    <app-piezo-alerts></app-piezo-alerts>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- ================= MODALS ================= -->

<app-piezo-dashboard-modal *ngIf="modal_type === 'list_gateways'" [modal_type]="modal_type"
    (close_modal)="closeModal()"></app-piezo-dashboard-modal>

<app-piezo-dashboard-modal *ngIf="modal_type === 'list_sensors'" [modal_type]="modal_type" [subsystem_id]="subsystem_id"
    (close_modal)="closeModal()"></app-piezo-dashboard-modal>

<app-piezo-dashboard-modal *ngIf="modal_type === 'delete_powertrain'" [modal_type]="modal_type"
    [subsystem_id]="subsystem_id" [client_id]="client_id" (close_modal)="closeModal()"></app-piezo-dashboard-modal>